<template>
  <div>
    <div class="end">
      Copyright © 2026 备案号:
      <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备15030000号-0</a>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802037085" target="_blank"
         class="margin-lr-xs">
<!--        <img src="http://www.beian.gov.cn/img/new/gongan.png" alt="">-->
        公安备案号：11010802000000</a>
      <br>技术支持：北京易魔方科技集团有限公司
    </div>
  </div>
</template>
<script>
export default {
  name: "footerpage",
  data() {
    return {}
  },
  components: {},
  created() {

  },
  methods: {},
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.end {
  width: 100%;
  padding: 20px 0;
  background-color: #0115a6;
  font-size: 14px;
  color: #fff;
  text-align: center;
  line-height: 26px;

  a {
    color: #fff;
    img {
      margin-right: 4px;
    }
  }
}
</style>


